import { render, staticRenderFns } from "./MoblieHorizontal.vue?vue&type=template&id=0002a8d8&scoped=true"
import script from "./MoblieHorizontal.vue?vue&type=script&lang=js"
export * from "./MoblieHorizontal.vue?vue&type=script&lang=js"
import style0 from "./MoblieHorizontal.vue?vue&type=style&index=0&id=0002a8d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0002a8d8",
  null
  
)

export default component.exports